module.exports = __webpack_public_path__ + "img/edit-active.6aca2aff.svg";